import { queryOptions } from "@tanstack/react-query";
import type { getDeviceListForm, DEVICE_CATEGORY_TYPE, PARTNER_DEVICE_CATEGORY_TYPE } from "../dtos/request/device.request";
import { getDeviceList, getDeviceDetail, getDeviceQuotationList, getDeviceFromPartner } from "../v1/device.service";

export const useDeviceList = (form: getDeviceListForm) =>
  queryOptions({
    queryKey: [
      "device-list",
      form.page,
      form.size,
      form.category,
      form.defaultOnly,
    ],
    queryFn: () => getDeviceList(form),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

export const useDeviceDetail = (id: string) =>
  queryOptions({
    queryKey: ["device-detail", id],
    queryFn: () => getDeviceDetail(id),
    enabled: !!id,
    retry: 1,
  });

export const useDeviceQuotationList = (type: DEVICE_CATEGORY_TYPE) =>
  queryOptions({
    queryKey: ["device-quotation-list", type],
    queryFn: () => getDeviceQuotationList(type),
    enabled: !!type,
    retry: 1,
  });

/**
 * 제휴용 기종 API(/v1/device/fromPartner) 사용 여부.
 * true: fromPartner 우선, 실패(404/파라미터 불일치 등) 시 기존 /v1/device?category= 로 폴백.
 * false: 지점 시세표와 동일한 /v1/device?category= 만 사용.
 * → fromPartner 가 200 이지만 빈 배열을 내려 제휴 항목 추가 모달이 비어 보이는 이슈로 false 고정 (2026-09-18)
 */
export const USE_PARTNER_DEVICE_API = false;

/** 제휴용 기종 리스트 — 여러 카테고리를 한 번에 합쳐서 돌려준다 (주요폰 모달: GALAXY+IPHONE, 키즈: KIDS) */
export const useDeviceFromPartner = (categories: PARTNER_DEVICE_CATEGORY_TYPE[]) =>
  queryOptions({
    queryKey: ["device-from-partner", ...categories],
    queryFn: async () => (await Promise.all(categories.map((c) => getDeviceFromPartner(c)))).flat(),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
